import { Component } from '@angular/core';
import{Router, NavigationEnd} from '@angular/router';
declare let gtag: Function;
import { DetalleUsuarioService } from './Services/detalle-usuario.service';
import { ListaEmpresasService } from './Services/lista-empresas.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'certificadoHonorariosDCyF';
  rut;
  constructor(public router: Router,
              public listaEmprService: ListaEmpresasService,
              public detalleUsuarioService: DetalleUsuarioService){   
    //console.log(this.rut);
    this.detalleUsuarioService.getVariableCompartida().subscribe(datos => {
      //console.log(datos);
      this.rut = datos;
    });
    if (this.rut=="0"||this.rut==null) {
      this.cerrar();
      return;
    }

    
    this.router.events.subscribe(event => {
       if(event instanceof NavigationEnd){
           gtag('config', 'UA-10529528-23', 
           'event', 'Fin de la solicitud',
                 {
                   'page_path': event.urlAfterRedirects,
                   'event_category': 'Trámite digital',
                   'event_label': 'Trámite - 1000830000',
                   'value': '0' 
                 }
                );
        }
     }
  )}
  cerrar(){
    this.listaEmprService.limpiarDatos();
    this.detalleUsuarioService.limpiarDatos();
    this.detalleUsuarioService.limpiarRut();
    localStorage.clear();
    this.router.navigate(['/inicio']);
  }
}
 